export const en = {
    perWeek: 'per week'
};
